export const getDateFormat = (date?: string) => {
  if (!date) {
    return null;
  }
  const toDate = new Date(date);
  return toDate.toISOString().split("T")[0];
};
